export const BASE_BACKOFF_MS = 1_000;
export const MAX_BACKOFF_MS = 30_000;

// Bounds the 5xx case. One backend endpoint answers 500 rather than 404 for a missing entity,
// so a permanently absent job would otherwise be retried forever.
export const MAX_CONSECUTIVE_FAILURES = 5;

export type SseFailure = { kind: 'http'; status: number } | { kind: 'network' };

export type SseFailureAction = 'retry' | 'refresh' | 'fatal';

const RETRYABLE_CLIENT_STATUSES = new Set([408, 425, 429]);

export function classifyFailure(failure: SseFailure): SseFailureAction {
    if (failure.kind === 'network') {
        return 'retry';
    }

    // 498 is the gateway's "refresh me" status: it is the only one ProxyServerConnector
    // .handleResponseStatus turns into REFRESH_TOKEN_NEEDED. 401 is kept as belt and braces
    // because the stream bypasses handleResponseStatus entirely.
    if (failure.status === 401 || failure.status === 498) {
        return 'refresh';
    }

    if (failure.status >= 500 || RETRYABLE_CLIENT_STATUSES.has(failure.status)) {
        return 'retry';
    }

    return 'fatal';
}

/** Equal jitter: half the capped delay plus a random half, so retries never synchronise. */
export function backoffDelayMs(attempt: number, random: () => number = Math.random): number {
    const capped = Math.min(MAX_BACKOFF_MS, BASE_BACKOFF_MS * 2 ** attempt);
    const half = capped / 2;

    return Math.round(half + random() * half);
}
